import { render, staticRenderFns } from "./SymptomList.vue?vue&type=template&id=cff62528&scoped=true"
import script from "./SymptomList.vue?vue&type=script&lang=js"
export * from "./SymptomList.vue?vue&type=script&lang=js"
import style0 from "./SymptomList.vue?vue&type=style&index=0&id=cff62528&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff62528",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/ap/jenkins/workspace/prod-ykd360-admin-front(医可达旧管理端)/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cff62528')) {
      api.createRecord('cff62528', component.options)
    } else {
      api.reload('cff62528', component.options)
    }
    module.hot.accept("./SymptomList.vue?vue&type=template&id=cff62528&scoped=true", function () {
      api.rerender('cff62528', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/seekBeauty/SymptomList.vue"
export default component.exports